import { BooleanField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { FollowUpSendTo, FollowUpTimeUnit, IFollowUpRelated } from '@/data/models/domain/types'

@OrmModel(modelNames.FOLLOW_UP_DETAILS)
export default class FollowUpDetails extends BaseModel implements IFollowUpRelated {
  @NumberField()
  public sendAfter: number

  @StringField()
  public sendAfterUnit: FollowUpTimeUnit

  @StringField()
  public sendTo: FollowUpSendTo

  @StringField(null)
  public relatedEmailCampaignId: string | null

  @StringField(null)
  public relatedScheduledEmailCampaignId: string | null

  @BooleanField()
  public isOrphan: boolean
}
